import { graphQLApi } from './index'

export default graphQLApi.middleware
